import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import AppHeader from "../../components/Header";
import { useNavigate } from "react-router-dom";
import iconError from "../../assets/svg/icon-error.svg";

type ErrorProps = {
  error: Error;
  resetErrorBoundary: () => void;
};

export default function ErrorFallBack(props: ErrorProps) {
  const { t } = useTranslation(["errors"]);
  const navigate = useNavigate();

  const reset = () => {
    props.resetErrorBoundary();
    navigate("/", { replace: true });
  };

  return (
    <>
      <AppHeader back />
      <ErrorStyled>
        <div className="main-container">
          <img src={iconError} alt="" />
          <div className="main">{t("errors:generic.title")}</div>
          <div className="desc">{t("errors:generic.sub")}</div>
        </div>
        <div className="button-container">
          <button type="button" onClick={reset}>
            {t("errors:generic.backHome")}
          </button>
        </div>
      </ErrorStyled>
    </>
  );
}

const ErrorStyled = styled.main`
  padding: 0 2rem;
  display: flex;
  flex-direction: column;

  .main-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      margin-bottom: 1.6rem;
    }

    .main {
      font-size: 1.8rem;
      font-weight: 600;
      color: var(--color-grey-900);
      margin-bottom: 0.4rem;
    }

    .desc {
      font-size: 1.4rem;
      color: var(--color-grey-500);
    }
  }

  .button-container {
    margin-bottom: 3.3rem;

    button {
      width: 100%;
      padding: 1.4rem 0;
      height: 5rem;
      background-color: var(--color-main);
      border-radius: 0.8rem;
      font-size: 1.6rem;
      font-weight: 600;
      color: var(--color-white);
    }
  }
`;
